import { render, staticRenderFns } from "./PriorityPicker.vue?vue&type=template&id=8ad413fa&scoped=true&"
import script from "./PriorityPicker.vue?vue&type=script&lang=js&"
export * from "./PriorityPicker.vue?vue&type=script&lang=js&"
import style0 from "./PriorityPicker.vue?vue&type=style&index=0&id=8ad413fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad413fa",
  null
  
)

export default component.exports